import { RelatedDataPollNewEvent, RelatedDataStoreProvider } from '../../related-data';
import { BoloRelatedDataTabContent } from './bolo-related-data-tab-content';
import { useBoloRelatedDataQueries } from './use-bolo-related-data-queries';

export const BoloRelatedDataTab = () => {
    const {
        vehicleQueries,
        personQueries,
        phoneNumbers,
        relatedDataLocationQuery,
    } = useBoloRelatedDataQueries();

    return (
        <RelatedDataStoreProvider>
            <RelatedDataPollNewEvent
                phoneNumbers={phoneNumbers}
                vehicleQueries={vehicleQueries}
                relatedDataLocationQuery={relatedDataLocationQuery}
                personQueries={personQueries}
            />
            <BoloRelatedDataTabContent
                vehicles={[]}
                reportingParties={[]}
                phoneNumbers={phoneNumbers}
                vehicleQueries={vehicleQueries}
                relatedDataLocationQuery={relatedDataLocationQuery}
                personQueries={personQueries}
            />
        </RelatedDataStoreProvider>
    );
};
